"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MessageListContent = void 0;
var _react = _interopRequireWildcard(require("react"));
var _style = require("./style");
var _MessageList = _interopRequireDefault(require("../MessageList"));
var _dateutil = require("../../../helpers/dateutil");
var _Message = _interopRequireDefault(require("../Message"));
var _MessageDate = require("../MessageDate");
var _messageUtil = require("../../../helpers/messageUtil");
var _MessageInput = _interopRequireDefault(require("../../containers/MessageInput"));
var _Header = _interopRequireDefault(require("../Header"));
var _platform = require("../../../helpers/platform");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
} // import ChatModBanner from '@olxbr/chat-mod-react-components-banner'
var scrolly = 0;
var MessageListContent = exports.MessageListContent = function MessageListContent(_ref) {
  var myAccountId = _ref.myAccountId,
    listId = _ref.listId,
    messages = _ref.messages,
    isTyping = _ref.isTyping,
    currentChat = _ref.currentChat,
    isSeller = _ref.isSeller,
    isOlxPay = _ref.isOlxPay,
    chatModBannerVariants = _ref.chatModBannerVariants,
    isAdview = _ref.isAdview,
    adSubject = _ref.adSubject,
    adPrice = _ref.adPrice,
    adImage = _ref.adImage,
    adStatus = _ref.adStatus,
    partner = _ref.partner,
    isAutoOpen = _ref.isAutoOpen;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    secondHidden = _useState2[0],
    setSecondHidden = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    predefinedHidden = _useState4[0],
    setPredefinedHidden = _useState4[1];
  var _renderItem = function _renderItem(_ref2, messages) {
    var message = _ref2.message,
      index = _ref2.index;
    var afterMessage = messages[index + 1];
    var _shouldShowDate = function _shouldShowDate(_ref3) {
      var timestamp = _ref3.timestamp,
        _ref3$afterTimestamp = _ref3.afterTimestamp,
        afterTimestamp = _ref3$afterTimestamp === void 0 ? null : _ref3$afterTimestamp;
      if (!afterTimestamp) return true;
      if (timestamp === Infinity) return false;
      var momentAfterTimestamp = (0, _dateutil.parseDate)(afterTimestamp).toDateString();
      var momentTimestamp = (0, _dateutil.parseDate)(timestamp).toDateString();
      return momentTimestamp !== momentAfterTimestamp;
    };
    var canShowDate = _shouldShowDate({
      timestamp: message === null || message === void 0 ? void 0 : message.timestamp,
      afterTimestamp: afterMessage === null || afterMessage === void 0 ? void 0 : afterMessage.timestamp
    });
    if (!myAccountId) {
      return null;
    }
    var sameUser = (afterMessage === null || afterMessage === void 0 ? void 0 : afterMessage.sender) === (message === null || message === void 0 ? void 0 : message.sender);
    var isNotification = (message === null || message === void 0 ? void 0 : message.customType) !== 'normal' && (message === null || message === void 0 ? void 0 : message.customType) !== 'image';
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react["default"].Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Message["default"], {
        message: message,
        myAccountId: myAccountId,
        listId: listId,
        isAdview: isAdview,
        partner: partner,
        isAutoOpen: isAutoOpen
      }), canShowDate && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_style.Spacer, {
          sameUser: false
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MessageDate.MessageDate, {
          timestamp: message === null || message === void 0 ? void 0 : message.timestamp
        }), sameUser && /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.SpacerDate, {})]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.Spacer, {
        sameUser: sameUser && !isNotification
      })]
    }, "".concat(message.id, "_").concat(message.customType));
  };
  var _renderMessages = function _renderMessages(messages) {
    var sortedMessages = _sortSpecialMessages(messages);
    return sortedMessages.reverse().map(function (message, index) {
      return _renderItem({
        message: message,
        index: index
      }, sortedMessages);
    });
  };
  var _sortSpecialMessages = function _sortSpecialMessages(messages) {
    var groupedMessages = messages.reduce(function (memo, item) {
      var key = (0, _messageUtil.isMessageFromUser)(item) ? 'ordered' : 'toOrder';
      memo[key].push(item);
      return memo;
    }, {
      ordered: [],
      toOrder: []
    });
    groupedMessages.toOrder.forEach(function (item) {
      groupedMessages.ordered = _insertMessageOrdered(groupedMessages.ordered, item);
    });
    return groupedMessages.ordered;
  };
  var _insertMessageOrdered = function _insertMessageOrdered(messages, item) {
    var inserted = false;
    for (var i = 0; i < messages.length; i += 1) {
      if (item.timestamp < messages[i].timestamp) {
        inserted = true;
        messages.splice(i, 0, item);
        break;
      }
    }
    if (!inserted) {
      messages.push(item);
    }
    return messages;
  };
  var messageList = _toConsumableArray(messages);
  if (isTyping) {
    messageList.push({
      customType: 'typing',
      timestamp: Infinity
    });
  }
  var getScrollDirection = function getScrollDirection(scrollTop) {
    var direction = scrollTop > scrolly ? 'forward' : 'backward';
    scrolly = scrollTop;
    return direction;
  };
  var timeoutId = null;
  var scrollEvent = function scrollEvent(_ref4) {
    var currentTarget = _ref4.currentTarget;
    var scrollTop = currentTarget.scrollTop,
      scrollHeight = currentTarget.scrollHeight,
      clientHeight = currentTarget.clientHeight;
    if (timeoutId) return;
    if (scrollTop <= 0) return;
    if (scrollHeight - scrollTop <= clientHeight + 100) return;
    timeoutId = window.setTimeout(function () {
      var direction = getScrollDirection(scrollTop);
      setSecondHidden(direction === 'backward' && _platform.isMsite);
      timeoutId = null;
    }, 200);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_style.Wrapper, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Header["default"], {
      isAdview: isAdview,
      listId: listId,
      adSubject: adSubject,
      adPrice: adPrice,
      adImage: adImage,
      secondHidden: secondHidden,
      adStatus: adStatus,
      currentChat: currentChat
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_MessageList["default"], {
      isAdview: isAdview,
      currentChat: currentChat,
      messageCount: messageList.length,
      overScrollMode: 'always',
      scrollEvent: scrollEvent,
      scrollEventThrottle: 200,
      predefinedHidden: predefinedHidden,
      secondHidden: secondHidden,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_style.ChatMobBannerWrapper, {}), _renderMessages(messageList)]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MessageInput["default"], {
      isAdview: isAdview,
      setPredefinedHidden: setPredefinedHidden,
      secondHidden: secondHidden
    })]
  });
};